// extracted by mini-css-extract-plugin
export default {"chip":"Z8qzOR06RsM064rChNqr"};